var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { EntriesSelectedViaDrag } from '../state/actions/events';
import { Store } from '@ngxs/store';
import { DriveDomCacheService } from './drive-dom-cache.service';
import { DriveState } from '../state/drive-state';
import * as i0 from "@angular/core";
import * as i1 from "@ngxs/store";
import * as i2 from "./drive-dom-cache.service";
var GRID_ITEM_SELECTOR = 'files-grid-item';
var FilesDragSelectService = /** @class */ (function () {
    function FilesDragSelectService(store, cache) {
        this.store = store;
        this.cache = cache;
        this.initial = { x: 0, y: 0, scrollTop: 0 };
    }
    FilesDragSelectService.prototype.start = function (e) {
        this.cacheClientRects();
        this.createSelectBox();
        this.bindScroll();
        this.initial = __assign({}, this.hammerToRelative(e), { scrollTop: this.cache.scrollCont.scrollTop });
        this.selectBox.style.top = this.initial.y + 'px';
        this.selectBox.style.left = this.initial.x + 'px';
    };
    FilesDragSelectService.prototype.move = function (e) {
        this.lastPanEvent = e;
        this.resizeBox(e);
    };
    FilesDragSelectService.prototype.end = function () {
        this.removeSelectBox();
        this.dispatchSelectedAction();
        this.unbindScroll();
    };
    FilesDragSelectService.prototype.resizeBox = function (e) {
        if (!e)
            e = this.lastPanEvent;
        if (!e || !this.selectBox)
            return;
        var newPos = this.getNewSelectorPosition(e);
        this.scrollAndRepositionSelector(newPos);
        this.selectIntersectingElements();
    };
    /**
     * Calculate new position of selector box.
     */
    FilesDragSelectService.prototype.getNewSelectorPosition = function (e) {
        var current = this.hammerToRelative(e);
        var tmp, x1 = this.initial.x, y1 = this.initial.y, x2 = current.x, y2 = current.y;
        if (x1 > x2) {
            tmp = x2;
            x2 = x1;
            x1 = tmp;
        }
        if (y1 > y2) {
            tmp = y2;
            y2 = y1;
            y1 = tmp;
        }
        return {
            width: x2 - x1,
            height: y2 - y1,
            top: y1,
            right: x1 + (x2 - x1),
            bottom: y1 + (y2 - y1),
            left: x1,
        };
    };
    /**
     * Check if specified position intersects any container edge.
     */
    FilesDragSelectService.prototype.reachedAreaEdge = function (newPos) {
        var area = this.rectToRelative(this.cache.filesContRect);
        if (newPos.left <= area.left) {
            return 'left';
        }
        else if (newPos.top <= area.top) {
            return 'top';
        }
        else if (newPos.right >= area.right) {
            return 'right';
        }
        else if (newPos.bottom >= area.bottom) {
            return 'bottom';
        }
        return false;
    };
    /**
     * Auto scroll container (if needed) and reposition selector box.
     */
    FilesDragSelectService.prototype.scrollAndRepositionSelector = function (newPos) {
        var area = this.cache.scrollCont, edge = this.reachedAreaEdge(newPos);
        // make sure top always starts at the same coordinates
        // regardless of any scrolling done during dragging
        newPos.top += this.initial.scrollTop;
        // auto scroll when cursor reaches container edge
        if (edge === 'bottom') {
            area.scrollBy({ top: 4 });
        }
        else if (edge === 'top') {
            area.scrollBy({ top: -4 });
        }
        // scroll diff between drag start and now (auto scroll or mouse wheel)
        var scrollDiff = this.cache.scrollCont.scrollTop - this.initial.scrollTop, scrollValue = Math.abs(scrollDiff);
        // top needs to be changed only if scroll direction is top
        if (scrollDiff < 0) {
            newPos.top -= scrollValue;
        }
        // height needs to be changed regardless of direction and method
        newPos.height += scrollValue;
        // check if we have reached bottom edge again, after scroll values are applied
        var reachedBottom = (newPos.top + newPos.height) >= this.cache.scrollCont.scrollHeight;
        // if any select area edge is reached, bail
        if (edge === 'left' || edge === 'right' || reachedBottom)
            return;
        // finally, reposition select box with scroll values applied
        this.applyPosition(newPos);
    };
    /**
     * Apply specified position to selector box.
     */
    FilesDragSelectService.prototype.applyPosition = function (newPos) {
        this.selectBox.style.width = newPos.width + 'px';
        this.selectBox.style.height = newPos.height + 'px';
        this.selectBox.style.left = newPos.left + 'px';
        this.selectBox.style.top = newPos.top + 'px';
    };
    FilesDragSelectService.prototype.selectIntersectingElements = function () {
        var selectedBoxRect = this.selectBox.getBoundingClientRect();
        this.getGridElements().forEach(function (gridItem) {
            var rect = gridItem.getBoundingClientRect();
            // item intersects the select box
            if (rect.top + rect.height > selectedBoxRect.top
                && rect.left + rect.width > selectedBoxRect.left
                && rect.bottom - rect.height < selectedBoxRect.bottom
                && rect.right - rect.width < selectedBoxRect.right) {
                gridItem.classList.add('selected');
            }
            else {
                gridItem.classList.remove('selected');
            }
        });
    };
    /**
     * Transform absolute container client rect into relative.
     */
    FilesDragSelectService.prototype.rectToRelative = function (rect) {
        return {
            width: rect.width,
            height: rect.height,
            left: rect.left - this.cache.filesContRect.left,
            top: rect.top - this.cache.filesContRect.top,
            right: rect.right - this.cache.filesContRect.left,
            bottom: rect.bottom - this.cache.filesContRect.top
        };
    };
    /**
     * Transform hammer absolute event to relative coordinates.
     */
    FilesDragSelectService.prototype.hammerToRelative = function (e) {
        return {
            x: e.center.x - this.cache.filesContRect.left,
            y: e.center.y - this.cache.filesContRect.top
        };
    };
    FilesDragSelectService.prototype.dispatchSelectedAction = function () {
        var ids = this.getGridElements()
            .filter(function (el) { return el.classList.contains('selected'); })
            .map(function (el) { return +el.dataset.id; });
        var entries = this.store.selectSnapshot(DriveState.entries)
            .filter(function (entry) { return ids.indexOf(entry.id) > -1; });
        this.store.dispatch(new EntriesSelectedViaDrag(entries));
    };
    FilesDragSelectService.prototype.createSelectBox = function () {
        this.selectBox = document.createElement('div');
        this.selectBox.classList.add('files-select-box');
        this.cache.filesCont.appendChild(this.selectBox);
    };
    FilesDragSelectService.prototype.removeSelectBox = function () {
        if (!this.selectBox)
            return;
        this.selectBox.remove();
        this.selectBox = null;
    };
    FilesDragSelectService.prototype.cacheClientRects = function () {
        this.cache.filesContRect = this.cache.filesCont.getBoundingClientRect();
        this.cache.scrollContRect = this.cache.scrollCont.getBoundingClientRect();
    };
    FilesDragSelectService.prototype.getGridElements = function () {
        return Array.from(this.cache.filesCont.querySelectorAll(GRID_ITEM_SELECTOR));
    };
    FilesDragSelectService.prototype.bindScroll = function () {
        var _this = this;
        this.scrollListener = function () { return _this.resizeBox(); };
        this.cache.scrollCont.addEventListener('scroll', this.scrollListener);
    };
    FilesDragSelectService.prototype.unbindScroll = function () {
        this.cache.scrollCont.removeEventListener('scroll', this.scrollListener);
    };
    FilesDragSelectService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function FilesDragSelectService_Factory() { return new FilesDragSelectService(i0.ɵɵinject(i1.Store), i0.ɵɵinject(i2.DriveDomCacheService)); }, token: FilesDragSelectService, providedIn: "root" });
    return FilesDragSelectService;
}());
export { FilesDragSelectService };
